import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Spinner } from '../components/ui/Spinner';
import { useSession } from './session';

/**
 * Route gate for player-only pages.
 *
 * This is navigation convenience, not security: every protected endpoint is
 * re-authorized by the server, which is the only thing that decides what a
 * session may read or change.
 */
export function RequireAuth() {
  const { isAuthenticated, isRestoring } = useSession();
  const location = useLocation();

  if (isRestoring) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner className="text-primary size-6" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <Outlet />;
}
